/* ==========================================================================
   MODULE: PARENT INFO SECTIONS & INTERFACE LIFECYCLES (parentInfo.js)
   ========================================================================== */

/**
 * MASTER INITIALIZATION PATH: Binds all parent section event listeners safely
 */
export function initParentInfo() {
  const attendanceSelect = document.getElementById('parentAttendingBeginner');
  const parentRelation = document.getElementById('parentRelation');
  const secondParentRelation = document.getElementById('secondParentRelation');
  const otherRelationshipWrapper = document.getElementById('otherRelationshipWrapper');
  const secondParentOtherRelationshipWrapper = document.getElementById('secondParentOtherRelationshipWrapper');

  // 1. Bind master dropdown change monitor loop
  if (attendanceSelect) {
    attendanceSelect.addEventListener('change', () => {
      console.log(`[Parent UI] Attendance drop-down adjusted to value: "${attendanceSelect.value}"`);
      handleAttendanceOptionChange();
    });
  }

  // 2. Bind custom "Other" relationship text input triggers
  if (parentRelation) {
    parentRelation.addEventListener('change', () => {
      handleRelationshipChange('parentRelation', 'otherRelationshipWrapper', 'parentRelationOther');
    });
  }

  if (secondParentRelation) {
    secondParentRelation.addEventListener('change', () => {
      handleRelationshipChange('secondParentRelation', 'secondParentOtherRelationshipWrapper', 'secondParentRelationOther');
    });
  }

  // 3. Bind parent class session checkbox monitoring pipelines
  initParentDateCheckboxes('parent1ClassDates', 'parent1DatesHidden');
  initParentDateCheckboxes('parent2ClassDates', 'parent2DatesHidden');
}

/**
 * SHARED INTERFACE MANAGER: Manages input clusters, required flags, and layout visibility grids cleanly
 */
export function handleAttendanceOptionChange() {
  const parentAttendingBeginner = document.getElementById('parentAttendingBeginner');
  const parentLaptopMessage = document.getElementById('parentLaptopMessage');
  const choice = parentAttendingBeginner ? parentAttendingBeginner.value : '';

  const parent1Fields = ['parent1Laptop'];
  const parent2Fields = ['secondParentFirstName', 'secondParentLastName', 'secondParentRelation', 'parent2Laptop'];

  // Manage Parent 1 Layout Container Blocks
  const showParent1 = ['Same Parent', 'Two Parents'].includes(choice);
  toggleFieldBlock('firstParentFieldsWrapper', parent1Fields, showParent1);
  if (!showParent1) {
    document.querySelectorAll('input[name="parent1ClassDates"]').forEach(cb => { cb.checked = false; });
    const h1 = document.getElementById('parent1DatesHidden');
    if (h1) h1.value = '';
  }

  // Manage Parent 2 Layout Container Blocks
  const showParent2 = ['Different Parent', 'Two Parents'].includes(choice);
  toggleFieldBlock('secondParentFieldsWrapper', parent2Fields, showParent2);
  if (!showParent2) {
    document.querySelectorAll('input[name="parent2ClassDates"]').forEach(cb => { cb.checked = false; });
    const h2 = document.getElementById('parent2DatesHidden');
    if (h2) h2.value = '';
    
    // Explicitly reset the custom relationship sub-wrapper if parent 2 gets hidden
    const p2OtherDiv = document.getElementById('secondParentRelationOtherDiv');
    if (p2OtherDiv) p2OtherDiv.classList.add('d-none');
  }

  // Global mobile device instructions banner message toggle
  const anyParentAttending = ['Same Parent', 'Different Parent', 'Two Parents'].includes(choice);
  if (parentLaptopMessage) {
    parentLaptopMessage.classList.toggle('d-none', !anyParentAttending);
  }
}

/**
 * PUBLIC CLEANER TRIGGER: Wipes choices and resets hidden properties when users switch modules
 */
export function clearParentAttendanceFields() {
  const parentAttendingBeginner = document.getElementById('parentAttendingBeginner');
  if (parentAttendingBeginner) parentAttendingBeginner.value = '';
  
  handleAttendanceOptionChange(); 
}

/**
 * CORE LOGIC ENGINE: Toggles element blocks, adjusts required attributes, and strips data properties cleanly
 */
function toggleFieldBlock(wrapperId, fieldsArray, showBlock) {
  const wrapper = document.getElementById(wrapperId);
  if (!wrapper) return;

  if (showBlock) {
    wrapper.classList.remove('d-none');
    fieldsArray.forEach(id => {
      const field = document.getElementById(id);
      if (field && id !== 'parent1Laptop' && id !== 'parent2Laptop') {
        field.setAttribute('required', 'required');
      }
    });
  } else {
    wrapper.classList.add('d-none');
    fieldsArray.forEach(id => {
      const field = document.getElementById(id);
      if (field) {
        field.removeAttribute('required');
        if (field.type === 'checkbox') field.checked = false;
        else field.value = '';
      }
    });
  }
}

/**
 * RELATIONSHIP CONTEXT MONITOR: Handles checking dropdown options for "Other" flags
 */
function handleRelationshipChange(selectId, wrapperId, inputId) {
  const select = document.getElementById(selectId);
  const isOtherSelected = select?.value === 'Other';
  toggleFieldBlock(wrapperId, [inputId], isOtherSelected);
}

/**
 * CHECKBOX DATA COMPILER: Syncs chosen dates cleanly into single array strings inside hidden inputs
 */
function initParentDateCheckboxes(checkboxName, hiddenInputId) {
  const checkboxes = document.querySelectorAll(`input[name="${checkboxName}"]`);
  const hiddenInput = document.getElementById(hiddenInputId);

  if (checkboxes.length === 0 || !hiddenInput) return;

  checkboxes.forEach(cb => {
    cb.addEventListener('change', () => {
      const checkedValues = Array.from(document.querySelectorAll(`input[name="${checkboxName}"]:checked`))
        .map(checkedCb => checkedCb.value);
      
      hiddenInput.value = checkedValues.join(', ');
      console.log(`[Parent UI] Synchronized array strings for ${hiddenInputId}: "${hiddenInput.value}"`);
    });
  });
}
